/**
 * True if expiry date is strictly before today's calendar date (local timezone).
 * @param {string|Date|null|undefined} expiryDate - ISO date string or Date from API
 */
export function isEstimateExpiryPast(expiryDate) {
  if (expiryDate == null || expiryDate === '') return false;
  const expStr =
    typeof expiryDate === 'string'
      ? expiryDate.slice(0, 10)
      : (() => {
          const d = new Date(expiryDate);
          return Number.isNaN(d.getTime()) ? '' : d.toISOString().slice(0, 10);
        })();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(expStr)) return false;
  const now = new Date();
  const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  return expStr < todayStr;
}

/**
 * Status for UI badges: sent/accepted quotes past expiry_date show as expired
 * (DB status stays sent/accepted; no persisted `expired` status).
 */
export function getEffectiveEstimateStatus({ status, expiryDate }) {
  if (!status) return status;
  const s = String(status).toLowerCase();
  if (s === 'draft' || s === 'rejected' || s === 'converted' || s === 'queried') return s;
  if (s === 'accepted' || s === 'sent') {
    if (isEstimateExpiryPast(expiryDate)) return 'expired';
  }
  return s;
}
